import React, { useEffect } from "react";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import useAuthorization from "hooks/useAuthorization";

import FormSelectField from "components/FormFields/FormSelect";
import { MenuItem, Select } from "@mui/material";
import { CLINIC_NAMES } from "static/constants";

const UCHAccountModal = ({ handleSubmit, onUpdate, fields }) => {
  const { accessedAccountMappings } = useAuthorization();
  const filteredAccounts = accessedAccountMappings?.filter((account) =>
    account?.name?.includes("UCH")
  );

  useEffect(() => {
    const defaultAccount = filteredAccounts?.[0]?.name || "";
    onUpdate({ account: defaultAccount });
  }, []);

  return (
    <div>
      <ModalWrapper
        show={true}
        showTitle={true}
        maxWidth="sm"
        maxHeight="sm"
        showCloseIcon={false}
        headerStyle={{ padding: "4px 24px" }}
        title={
          <div className="d-flex flex-column mt-2">
            <h3>Specify Account</h3>
            <div
              style={{
                fontSize: "14px",
                fontWeight: "400",
                marginTop: "4px",
              }}
            >
              This patient belongs to UCH Account. Please change the account to
              upload the report.
            </div>
          </div>
        }
        children={
          <FormSelectField
            label="Account"
            required={true}
            customMapping={
              <Select
                style={{ minWidth: "120px" }}
                id="state"
                value={fields?.account}
                onChange={(e) => onUpdate({ account: e.target.value })}
              >
                {filteredAccounts?.map((account, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={account?.name}
                      style={account?.hide ? { display: "none" } : null}
                    >
                      {account?.name}
                    </MenuItem>
                  );
                })}
              </Select>
            }
          />
        }
        actionButtons={[
          {
            label: "Save & Update",
            variant: "contained",
            color: "secondary",
            onClick: handleSubmit,
            disabled: !fields?.account || fields?.account === CLINIC_NAMES.UCH,
          },
        ]}
      />
    </div>
  );
};

export default UCHAccountModal;
